<div class="flex flex-col" *ngIf="!isLoading; else loadingData">
  <!-- Encabezado -->
  <div
    class="rounded-t-[12px] border border-neutrals-300 bg-primary-100 flex items-center p-[12px_8px] self-stretch"
  >
    <!-- Icono camión -->
    <div
      class="w-[92px] h-[56px] flex flex-col items-center justify-end relative"
    >
      <div
        class="absolute top-[15px] left-0 right-0 h-[41px] bg-primary-200 rounded-[17px] z-0"
      ></div>
      <img
        src="icons/truck.svg"
        class="relative z-10 w-[86px] h-auto mb-[7px]"
      />
    </div>

    <!-- Texto bienvenida -->
    <div class="flex flex-col ml-2">
      <div class="flex gap-1">
        <ui-paragraph
          type="p16"
          mobile-type="p14"
          font-weight="regular"
          text-color="neutrals-900"
          content="Bienvenido,"
        />
        <ui-paragraph
          type="p16"
          mobile-type="p14"
          font-weight="semibold"
          text-color="neutrals-900"
          [content]="driverName | capitalizeName"
        />
      </div>
      <div class="flex gap-1 mt-1 items-center">
        <ui-paragraph
          class="bg-white rounded-[4px] px-[6px] py-1"
          type="p10"
          mobile-type="p10"
          font-weight="semibold"
          text-color="primary-700"
          content="Transportista"
        />
        <ui-paragraph
          *ngIf="sellerName && sellerName.trim().length > 0"
          class="bg-white rounded-[4px] px-[6px] py-1"
          type="p10"
          mobile-type="p10"
          font-weight="semibold"
          text-color="primary-700"
          [content]="sellerName"
        />
      </div>
    </div>
  </div>
  <!-- Puntos totales y ayuda -->
  <div
    class="rounded-b-[12px] border border-neutrals-300 bg-white flex justify-between items-center py-3 pl-3 pr-3"
  >
    <div class="flex items-center gap-4">
      <img src="icons/coin.png" alt="Moneda" class="w-8 h-8" />
      <div class="flex flex-col">
        <ui-paragraph
          type="p12"
          mobile-type="p10"
          font-weight="regular"
          text-color="neutrals-900"
          content="Puntos totales:"
        />
        <ui-paragraph
          type="p18"
          mobile-type="p16"
          font-weight="bold"
          text-color="neutrals-900"
          content="-"
        />
      </div>
    </div>
    <digicem-menu-tooltip
      icon="question-circle"
      fill="neutrals-600"
      size="20"
      mobileSize="20"
      [showButton]="false"
    >
      <div menuTooltipContent>
        <ui-paragraph
          text-color="neutrals-900"
          font-weight="bold"
          mobile-type="p14"
          type="p14"
          content="Puntos totales ganados"
          class="mb-2"
        />
        <ui-paragraph
          text-color="neutrals-900"
          font-weight="regular"
          mobile-type="p12"
          type="p12"
          content="Ganas puntos por cada entrega completada. ¡Mientras más pedidos entregues, más puntos acumulas!"
        />
      </div>
    </digicem-menu-tooltip>
  </div>
</div>

<ng-template #loadingData>
  <div class="flex flex-col">
    <div class="w-full h-20">
      <ngx-skeleton-loader
        class="w-full h-full"
        appearance="circle"
        count="1"
        [theme]="{
          width: '100%',
          height: '100%',
          borderRadius: '0.5rem',
          margin: '0',
        }"
      />
    </div>
    <div class="w-full h-16 mt-2">
      <ngx-skeleton-loader
        class="w-full h-full"
        appearance="circle"
        count="1"
        [theme]="{
          width: '100%',
          height: '100%',
          borderRadius: '0.5rem',
          margin: '0',
        }"
      />
    </div>
  </div>
</ng-template>
